import { vehicleRouteApi } from "../app/axios";

export const getCategorizedRoutes = async (route_category) => {
  return await vehicleRouteApi.get("/get-categorized-routes", {
    params: { route_category },
  });
};

export const getSpecificRoute = async (route_category, route_num_name) => {
  return await vehicleRouteApi.get("/get-specific-route", {
    params: { route_category, route_num_name },
  });
};

export const getSearchedRoutes = async (destination_1, destination_2) => {
  return await vehicleRouteApi.get("/get-searched-routes", {
    params: { destination_1, destination_2 },
  });
};

export const getAllPlaces = async (page, search) => {
  return await vehicleRouteApi.get("/get-all-places", {
    params: { page, search },
  });
};

export const getAllRouteNumCategories = async (page, search) => {
  return await vehicleRouteApi.get("/get-all-route-num-categories", {
    params: { page, search },
  });
};
